export default "__VITE_PUBLIC_ASSET__eca1f993__"